module.exports = require('jss-preset-default');